/**
 * Утилита для работы с медиа файлами (изображения и видео)
 */

/** Допустимые форматы изображений */
export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'];

/** Допустимые форматы видео */
export const VIDEO_EXTENSIONS = ['.mp4', '.mpeg', '.mpg', '.mov', '.avi', '.webm'];

/** Все допустимые медиа расширения */
export const MEDIA_EXTENSIONS = [...IMAGE_EXTENSIONS, ...VIDEO_EXTENSIONS];

/** Определяет, является ли файл видео по URL или имени файла */
export function isVideoFile(url: string): boolean {
  if (!url) return false;
  const lowerUrl = url.toLowerCase();
  return VIDEO_EXTENSIONS.some(ext => lowerUrl.endsWith(ext));
}

/** Определяет, является ли файл изображением по URL или имени файла */
export function isImageFile(url: string): boolean {
  if (!url) return false;
  const lowerUrl = url.toLowerCase();
  return IMAGE_EXTENSIONS.some(ext => lowerUrl.endsWith(ext));
}

/** Получает тип медиа файла */
export function getMediaType(url: string): 'video' | 'image' | 'unknown' {
  if (isVideoFile(url)) return 'video';
  if (isImageFile(url)) return 'image';
  return 'unknown';
}

/** Accept атрибут для input file с поддержкой изображений и видео */
export const MEDIA_ACCEPT = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
  'video/x-msvideo',
  'video/webm',
].join(',');

/** Форматирует размер файла в человекочитаемый формат */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}
